export const addresses = {
  svgHelperAddress: "0x7aca88Dc990fF22592D24310c04538b725e94Ffc",
  splatterAddress: "0x256Ba9c4DD146f3EBf0f7D0a3Ddea3F400CE806D",
  splatterArtAddress: "0xdfbf32A5d04aa5CD148415477591109B63b2bfB5",
  splatterToken: "0x5743cF32FfD4C1F2093AE2C94E1d036B6472E7B9",
};
